import { useEffect } from 'react';
import * as THREE from 'three'
import { Line } from 'three';
import { LineBasicMaterial } from 'three';
import { 
    BoxBufferGeometry, 
    Mesh,
    MeshNormalMaterial,
    PointsMaterial,
    Float32BufferAttribute,
    TextureLoader,
    BufferGeometry,
    Points,
    PerspectiveCamera,
    AxesHelper,
    WebGLRenderer,
    Group,

} from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'

const Anime = (landmarks)=>{

    // Load circles (PLD design)
    const textureLoader = new TextureLoader()
    //const circleTexture = textureLoader.load('./circle.png')
    const alphaCircle = textureLoader.load('./alphaCircle.png')

    // Create a scene
    const scene = new THREE.Scene();
    // Change scene background
    scene.background = new THREE.Color( 0xa0a0a0 );

    // Foggy scene :
    scene.fog = new THREE.Fog( 0xa0a0a0, 70, 100 );

    // Add grid to ground
    const grid = new THREE.GridHelper( 5, 20, 0x000000, 0x000000 );
	grid.material.opacity = 0.2;
	grid.material.transparent = true;
    scene.add( grid );


    // add axes : X,Y and Z
    scene.add(new AxesHelper())


    // add camera perspective :
    const camera = new PerspectiveCamera(
        75,
        window.innerWidth/window.innerHeight,
        0.01,
        1000
        )
    camera.position.z = 2
    camera.position.y = 0.5
    camera.position.x = 0.5
    scene.add(camera)

    // Points coordinates
    const points = new Float32Array( [
        0.5056262016296387,0.30761078000068665,0.6,
        0.5056262016296387,0.6,0.6,
    ] )

    // Create the geometry for points :
    const geometry = new BufferGeometry()

    // Points positions (from the coordinates)
    geometry.setAttribute('position',new Float32BufferAttribute(points,3))
    const pointMaterial = new PointsMaterial({
        color:0xff0000,
        size:0.05,
        //map:circleTexture,
        alphaTest:0.01,
        alphaMap:alphaCircle,
        transparent:true,
    })
    const pointsObject = new Points(geometry,pointMaterial)
    scene.add(pointsObject)

    const group = new Group()
    group.add(pointsObject)

    // Design the lines that will connect points
    const lineMaterial = new LineBasicMaterial({
        color:0xffffff,
        opacity:.05,
        depthWrite:false,
    })
    const lineObject = new Line(geometry,lineMaterial)
    group.add(lineObject)

    scene.add(group)



    const renderer = new WebGLRenderer({
        antialias: true,
    })
    renderer.setSize(window.innerWidth,window.innerHeight)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio,2))
    document.body.appendChild(renderer.domElement)

    const controls = new OrbitControls(camera,renderer.domElement)

    function tick(){
        renderer.render(scene,camera)
        controls.update()
        group.rotateY(0.001)
        console.log(group)
        //camera.position.x +=0.01
        //camera.lookAt(0,0,0)
        requestAnimationFrame(tick)
    }
    tick()

    useEffect(()=>{
        //
    },[])

    window.addEventListener('resize',()=>{
        camera.aspect = window.innerWidth / window.innerHeight
        camera.updateProjectionMatrix()
        renderer.setSize(window.innerWidth,window.innerHeight)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio,2))
    })

    return(
        <div></div>
    )
}

export default Anime